import { Crosshair } from "lucide-react";
import { mediaUrl } from "../../lib/api";

export default function FocalPointPicker({ imageUrl, value, onChange, testId }) {
  const focal = value || "50% 0%";
  const [x = "50", y = "50"] = focal.split(" ");

  const choose = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const nextX = Math.max(0, Math.min(100, Math.round(((event.clientX - rect.left) / rect.width) * 100)));
    const nextY = Math.max(0, Math.min(100, Math.round(((event.clientY - rect.top) / rect.height) * 100)));
    onChange(`${nextX}% ${nextY}%`);
  };

  return (
    <div data-testid={testId} className="mt-3 rounded-md border border-[#E5DED4] bg-[#FBF9F5] p-3">
      <div className="flex items-center justify-between gap-3 mb-2">
        <p className="text-[10px] uppercase tracking-[0.16em] font-sans font-semibold text-[#A0988E]">
          Photo focal point
        </p>
        <span data-testid={`${testId}-value`} className="text-[10px] font-mono text-[#9A7B66]">{focal}</span>
      </div>
      {imageUrl ? (
        <div
          role="button"
          tabIndex={0}
          data-testid={`${testId}-surface`}
          onClick={choose}
          className="relative h-52 rounded-md overflow-hidden cursor-crosshair bg-white"
          aria-label="Choose photo focal point"
        >
          <img
            src={mediaUrl(imageUrl)}
            alt="Focal point preview"
            className="w-full h-full object-cover"
            style={{ objectPosition: focal }}
          />
          <span
            data-testid={`${testId}-marker`}
            className="absolute w-5 h-5 -ml-2.5 -mt-2.5 rounded-full border-2 border-white bg-[#9A7B66]/80 shadow-lg pointer-events-none"
            style={{ left: `${x.replace("%", "")}%`, top: `${y.replace("%", "")}%` }}
          />
          <span className="absolute inset-0 grid grid-cols-3 grid-rows-3 pointer-events-none">
            {Array.from({ length: 9 }).map((_, index) => (
              <span key={index} className="border border-white/20" />
            ))}
          </span>
        </div>
      ) : (
        <div className="h-24 rounded-md bg-white border border-dashed border-[#D8CBB8] flex items-center justify-center text-[#A0988E]">
          <Crosshair className="w-5 h-5" />
        </div>
      )}
      <p className="mt-2 text-[11px] text-[#A0988E] font-sans">Click the photo where the important subject should stay visible.</p>
    </div>
  );
}
